<loader *ngIf="loading"></loader>

<ui-table
  *ngIf="data"
  [data]="data"
  [isWrapped]="false"
  [tblColor]="true"
  [tblRoundBottom]="true"
  (requestUpdate)="loadDataOnPagination($event)"
  [totalRecords]="searchMetaData.totalRecords"
  [numberOfRows]="numberOfRows"
  [displayFilter]="['rcptId', 'rcptDateFormatted']"
  [templates]="[
    {
      title: 'translate.general.clinic',
      template: clinicDescr,
      permission: !clinicUserSw
    },
    {
      title: 'translate.general.rcptTotSum',
      template: rcptTotSum,
      colClass: 'l-ltr'
    },
    {
      title: 'translate.general.invId',
      template: invId
    },
    {
      title: 'translate.reports.viewDocument',
      template: viewPdf
    }
  ]"
></ui-table>

<ng-template #rcptTotSum let-row="row">
  <div class="l-ltr l-ta-right" *ngIf="row.rcptTotSum">
    <span class="l-num">{{ row.rcptTotSum | currency: "ILS" }}</span>
  </div>
</ng-template>

<ng-template #invId let-row="row">
  {{ row.invId }}
</ng-template>

<ng-template #clinicDescr let-row="row">
  {{ row.clinicDescr }}
</ng-template>

<ng-template #viewPdf let-row="row">
  <div>
    <spinner *ngIf="row.docLoading"></spinner>
    <i
      *ngIf="!row.docLoading"
      class="icon-view-doc t-pointer fas fa-file-pdf c-success"
      (click)="onRowSelect(row)"
    ></i>
  </div>
</ng-template>
